import React from 'react';
import styles from './styles.module.css';
import * as Icon from '../../components/Icons'
import cn from 'classnames'
import { Col, Row } from 'react-flexbox-grid';
import { Link } from 'react-router-dom';
const SearchResultCard = ({ img }) => {
  return (
    <div className={styles.main}>
      <Row style={{ width: "100%" }}>
        <Col lg={8} sm={8} xs={12}>
          <div className={styles.subMain}>
            <div>
              <img
                src={
                  img
                }
                alt="card"
                className={styles.image}
              />
            </div>
            <div className={styles.mainContent}>
              <p className={styles.title}>Hotel Name</p>
              <p className={styles.star}>&#9733; &#9733; &#9733; &#9734; &#9734;</p>
              <p className={cn([styles.grayText, styles.address])}><Icon.Pin /> 08460 North Male Atoll, Maldives</p>
              <div className={styles.hotelReviews}>
                <ul>
                  <li className={styles.reviewAvg}>Excelent 9.6</li>
                  <li className={styles.reviewCount}>- 388 reviews</li>
                  <li className={styles.reviewHearth}><Icon.Hearth /></li>
                </ul>
              </div>
            </div>
          </div>
        </Col>
        <Col lg={4} sm={4} xs={12}>
          <div className={styles.summary}>
            <p className={styles.from}>From</p>
            <p className={styles.price}>SAR 456</p>
            <p className={styles.from}>Night</p>
            <Link to={"/hotel"}>
              <button className={styles.button}>
                See Availability
              </button>
            </Link>
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default SearchResultCard;
